import "./Utils.css";

export const BadgeEstado = ({ estado }) => {
    const ESTADO_CONFIG = {
        disponible: { label: "Disponible", className: "disponible" },
        reservado: { label: "Reservado", className: "reservado" },
        confirmado: { label: "Confirmado", className: "confirmado" },
        realizado: { label: "Realizado", className: "realizado" },
        cancelado: { label: "Cancelado", className: "cancelado" },
    };
    const config = ESTADO_CONFIG[estado] || { label: estado, className: "disponible" };
    return <span className={`badge badge--${config.className}`}>{config.label}</span>;
};

export const EmptyState = ({ icon, title, subtitle }) => (
    <div className="empty-state">
        {icon}
        <p>{title}</p>
        {subtitle && <span>{subtitle}</span>}
    </div>
);

export const FiltroEstado = ({ options, value, onChange }) => (
    <div className="estado-filtros" role="group" aria-label="Filtrar turnos por estado">
        {options.map((opt) => (
            <button
                key={opt.value}
                type="button"
                className={`estado-filtros__chip${value === opt.value ? " estado-filtros__chip--activo" : ""}`}
                onClick={() => onChange(opt.value)}
            >
                {opt.label}
            </button>
        ))}
    </div>
);